import React from "react";
import { IWizardContext } from ".";
import { IWizardStep } from "..";

export interface IWizardContextProps {
    children: React.ReactNode;
}

export const WizardContext = React.createContext<IWizardContext>({
    UpdateSetStep: (() => { return; }),
    SetStep: (tabIndex: number) => {
        return;
    },

    UpdateSteps: (() => { return; }),
    Steps: [],

    UpdateIsCompleting: (() => { return; }),
    IsCompleting: false,
});

export const WizardContextProvider = (({ children }: IWizardContextProps) => {

    const [SetStep, UpdateSetStep] = React.useState(() => (tabIndex: number) => { return; });
    const [Steps, UpdateSteps] = React.useState<IWizardStep[]>([]);
    const [SubmitWizard, UpdateSubmitWizard] = React.useState(() => () => Promise.resolve());
    const [ShouldSaveOnSubmit, UpdateShouldSaveOnSubmit] = React.useState(false);
    const [IsCompleting, UpdateIsCompleting] = React.useState(false);

    return (
        <WizardContext.Provider value={
            {
                UpdateSetStep,
                SetStep,

                UpdateSteps,
                Steps,

                UpdateSubmitWizard,
                SubmitWizard,

                UpdateShouldSaveOnSubmit,
                ShouldSaveOnSubmit,

                UpdateIsCompleting,
                IsCompleting,
            }}
        >
            {children}
        </WizardContext.Provider>
    );
});
